// extracted by mini-css-extract-plugin
export default {"value":"PtProgress_value__mPFbI","path":"PtProgress_path__UPeJT"};